<template>
  <div>
    <span v-html="content"></span>
  </div>
</template>

<script lang='ts'>
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BlockBodyComponent extends Vue {
  @Prop({ default: '' })
  public content!: string;
}
</script>
